/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const ROW_AXIS = "commodities.default";
const COLUMN_AXIS = "calendar.default";

export function useChartData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, columnsDict] = useDictionary(dictionaryService, "calendar-origin");
  const [itemsRows, rowsDict] = useDictionary(dictionaryService, "slides-commodities");
  const [itemsRowsDisplay] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    'slide': SLIDE_NUMBER,
    'business_unit': 1
  });

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict, rowsDict, itemsRows, itemsRowsDisplay].some(x => !Boolean(x))) {
      return null;
    }

    const commoditiesNames = new Map<number, unknown>(itemsRowsDisplay!.map(e => [Number(e.getValue('olap_commodity')), e.getValue('name')]));
    itemsRows
      ?.filter(e => !commoditiesNames.has(Number(e.id)))
      .forEach(e => commoditiesNames.set(Number(e.id), e.getValue('name')));

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${ROW_AXIS}.name`, (id: unknown, lcid: number) => {
          return commoditiesNames.get(Number(id)) || { [lcid]: '' };
        }]
      ]),
      attrsDictionaries: new Map([
        [COLUMN_AXIS, columnsDict],
        [ROW_AXIS, rowsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, columnsDict, rowsDict, itemsRows, itemsRowsDisplay]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${COLUMN_AXIS}.name`, `${ROW_AXIS}.name`, `${COLUMN_AXIS}.id`, `${ROW_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
